import { render, staticRenderFns } from "./RsaAccettazioneAnagraficaViewComponent.vue?vue&type=template&id=76b83114"
import script from "./RsaAccettazioneAnagraficaViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaAccettazioneAnagraficaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports